import { merge } from 'lodash-es'

import { buildNotification } from 'components/event_type_edit'

import { notificationToggleToServerData } from '../../notifications/subsections/config'

// The basic-notification activation toggles (email reminder, text reminder, email
// follow-up) that live on the CRUD notifications landing view. In the CRUD editor
// these are driven by the shared root form state instead of an immediate PATCH, so
// their enabled flags participate in the parent save. The server payload mirrors the
// legacy `toggleActivation` behavior exactly (full custom_notifications base merged
// with the per-kind toggle attributes) so no business logic changes.
export const NOTIFICATION_TOGGLE_KINDS = [
  'invitee_reminder',
  'invitee_sms_reminder',
  'invitee_email_follow_up'
]

export const getNotificationToggleInitialValues = (eventType) => ({
  notificationEnabled: NOTIFICATION_TOGGLE_KINDS.reduce((enabledByKind, kind) => ({
    ...enabledByKind,
    [kind]: !!eventType.custom_notifications?.[kind]?.enabled
  }), {})
})

export const formatNotificationToggleValues = ({ eventType, values, initialValues }) => {
  const changedKinds = NOTIFICATION_TOGGLE_KINDS.filter((kind) => (
    values?.notificationEnabled?.[kind] !== initialValues?.notificationEnabled?.[kind]
  ))

  if (!changedKinds.length) return {}

  return changedKinds.reduce((attributes, kind) => {
    const notification = buildNotification(eventType, kind)
    notification.enabled = values.notificationEnabled[kind]

    return merge(attributes, notificationToggleToServerData(notification))
  }, { custom_notifications: eventType.custom_notifications })
}
